import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_339_19"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <path d="M0 1.90735e-06H20V20H0V1.90735e-06Z" fill="white" />
    </mask>
    <g mask="url(#mask0_339_19)">
      <path
        d="M10 19C7.81818 15.639 4 11.083 4 7.16183C4 3.76419 6.6916 0.999999 10 0.999999C13.3084 0.999999 16 3.76419 16 7.16183C16 11.083 12.1818 15.639 10 19Z"
        stroke="#4D5F7A"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 9.96094C8.38465 9.96094 7.07031 8.6466 7.07031 7.03125C7.07031 5.4159 8.38465 4.10156 10 4.10156C11.6154 4.10156 12.9297 5.4159 12.9297 7.03125C12.9297 8.6466 11.6154 9.96094 10 9.96094Z"
        stroke="#4D5F7A"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export default SvgComponent;
